import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
`

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 980px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e8f0;
`

export const ModalHeader = styled.div`
  padding: 20px 24px 16px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
  gap: 16px;
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const HeaderTitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ModalTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
`

export const HeaderSubtitle = styled.p`
  font-size: 0.82rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`

export const HeaderMetricsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: 16px;
`

export const HeaderMetricBadge = styled.div<{ $variant?: 'neutral' | 'primary' | 'success' }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 92px;
  padding: 5px 16px;
  border-radius: 8px;
  background-color: ${({ $variant }) => {
    if ($variant === 'primary') return '#e0f2fe'
    if ($variant === 'success') return '#dcfce7'
    return '#f1f5f9'
  }};
  border: 1px solid ${({ $variant }) => {
    if ($variant === 'primary') return '#bae6fd'
    if ($variant === 'success') return '#86efac'
    return '#cbd5e1'
  }};
`

export const MetricLabel = styled.span`
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
`

export const MetricValue = styled.span<{ $variant?: 'neutral' | 'primary' | 'success' }>`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${({ $variant }) => {
    if ($variant === 'primary') return '#0369a1'
    if ($variant === 'success') return '#15803d'
    return '#0f172a'
  }};
  line-height: 1.1;
  white-space: nowrap;
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #0f172a;
  }
`

export const ModalBody = styled.div`
  padding: 20px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
`

export const TableContainer = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  overflow-x: auto;
`

export const GradeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-size: 0.875rem;
`

export const TableHead = styled.thead`
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;

  th {
    padding: 10px 14px;
    font-weight: 600;
    color: #475569;
    font-size: 0.8rem;
    white-space: nowrap;
    text-align: center;
  }
`

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f8fafc;
    }
  }

  td {
    padding: 8px 10px;
    vertical-align: middle;
    text-align: center;
  }
`

export const CellTam = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
`

export const CellGrade = styled.div`
  font-size: 0.95rem;
  font-weight: 600;
  color: #334155;
  text-align: center;
`

export const QuantityInput = styled.input`
  width: 64px;
  height: 36px;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  outline: none;
  transition: all 0.15s ease;

  &:focus {
    border-color: #0090d3;
    background: #ffffff;
    box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.2);
  }
`

export const CellRemainingOk = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #dcfce7;
  color: #15803d;
  border: 1px solid #86efac;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 0.78rem;
  font-weight: 700;
`

export const CellRemainingPending = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 0.78rem;
  font-weight: 700;
`

export const CellRemainingExceeded = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 0.78rem;
  font-weight: 700;
`

export const TableFooter = styled.tfoot`
  background-color: #f8fafc;
  border-top: 2px solid #e2e8f0;

  tr {
    background: transparent;
  }

  td {
    padding: 10px;
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    text-align: center;
  }
`

export const StatusNotice = styled.div<{ $isComplete: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: ${({ $isComplete }) => ($isComplete ? '#f0fdf4' : '#fffbeb')};
  border: 1px solid ${({ $isComplete }) => ($isComplete ? '#bbf7d0' : '#fde68a')};
  color: ${({ $isComplete }) => ($isComplete ? '#15803d' : '#b45309')};
`

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #f8fafc;
  gap: 12px;
`

export const CancelButton = styled.button`
  height: 38px;
  padding: 0 20px;
  background: #ffffff;
  border: 1px solid #0090d3;
  color: #0090d3;
  border-radius: 1.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`

export const SaveButton = styled.button`
  height: 38px;
  padding: 0 22px;
  background-color: #0090d3;
  color: #ffffff;
  border: none;
  border-radius: 1.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #0077b5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
